
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.364 12.766v4.598h-4.598v-4.598h4.598zm-1.532-9.962h2.299v1.533h1.15c.51 0 .957.191 1.34.574.383.384.575.83.575 1.341V19.28c0 .511-.192.958-.575 1.341-.383.383-.83.575-1.34.575H4.72c-.511 0-.958-.192-1.341-.575-.383-.383-.575-.83-.575-1.34V6.251c0-.51.192-.957.575-1.34.383-.384.83-.575 1.34-.575h1.15V2.804h2.3v1.533h7.663V2.804zM19.28 19.28V9.126H4.72V19.28h14.56z","fill":"#4788C6","fill-rule":"nonzero"}})])
          )
        }
      }
    